var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"3%"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"3"}}),_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('p',[_vm._v("Camera 1")]),_c('video',{attrs:{"width":"540","height":"380","autoplay":"","src":_vm.cameraUrl,"controls":""}})]),_c('v-col',{attrs:{"cols":"12","md":"6"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }